import { ActionTree } from 'vuex';
import axios from 'axios';
import { DomainState, Domain, RootState } from './domain-types';

export const actions: ActionTree<DomainState, RootState> = {
  async getDomain({ commit }): Promise<any> {
    await axios({ url: 'https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-domain' }).then(
      (response) => {
        const payload: Domain = response && response.data;
        commit('setDomainInState', payload);
      },
      (error) => {
        console.log(error);
        commit('profileError');
      },
    );
  },
};
